import { render, staticRenderFns } from "./CmgFullOrderDetailsModal.vue?vue&type=template&id=e3fcd98a&scoped=true&lang=pug&"
import script from "./cmg-full-order-details-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-full-order-details-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgFullOrderDetailsModal.vue?vue&type=style&index=0&id=e3fcd98a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3fcd98a",
  null
  
)

export default component.exports